// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSMessage/index.less
// module id = 664
// module chunks = 42